import {
  FETCH_DATASTREAM_AGGREGATE_MEASURE_FAILURE,
  FETCH_DATASTREAM_AGGREGATE_MEASURE_SUCCESS,
  FETCH_DATASTREAM_AGGREGATE_MEASURE_REQUEST,
  FETCH_MULTIPLE_DATASTREAMS_REQUEST,
  FETCH_MULTIPLE_DATASTREAMS_SUCCESS,
  FETCH_MULTIPLE_DATASTREAMS_FAILURE,
} from "../actions/realtimeDatastreamAggregateMeasure.actions";

const initialState = {
  data: null,
  loading: false,
};

const datastreamAggregateMeasure = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATASTREAM_AGGREGATE_MEASURE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_DATASTREAM_AGGREGATE_MEASURE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FETCH_DATASTREAM_AGGREGATE_MEASURE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case FETCH_MULTIPLE_DATASTREAMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_MULTIPLE_DATASTREAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_MULTIPLE_DATASTREAMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default datastreamAggregateMeasure;
